import { formatFromTotemTypeDenomination } from '@totem/business';

export function formatPrenom(prenom: string): string {
  return formatFromTotemTypeDenomination('prenom', prenom);
}

export function formatNom(nom: string): string {
  return formatFromTotemTypeDenomination('nom', nom);
}

export function formatNomComplet(
  prenom: string | undefined | null,
  nom: string | undefined | null,
  isNomFirst = false,
): string | undefined {
  const parts: string[] = [];

  if (prenom) {
    parts.push(formatPrenom(prenom));
  }

  if (nom) {
    if (isNomFirst) {
      parts.unshift(formatNom(nom));
    } else {
      parts.push(formatNom(nom));
    }
  }

  return parts.join(' ') || undefined;
}
